import { Injectable } from '@angular/core';
import { Order } from './models/Order';
import { HttpClient } from '@angular/common/http';
import { OrderSource } from './models/OrderSource';
import { OrderData } from './models/OrderData';
import { OrderEyeViewData } from './models/OrderEyeViewData';
import { OrderPodData } from './models/OrderPodData';
import { TemperatureTypeEnum } from './models/TemperatureTypeEnum';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor(private http$: HttpClient) { }

  createOrder(order: Order) {
    let formParams = new FormData();

    if (order.orderDocuments.documents) {
      for (let file of order.orderDocuments.documents) {
        formParams.append('files', file, file.name);
      }
    }

    formParams.append('model', JSON.stringify(order));
    return this.http$.post<Order>('/api/order', formParams);
  }

  updateOrder(order: Order, orderId: number) {
    let formParams = new FormData();

    if (order.orderDocuments.documents) {
      for (let file of order.orderDocuments.documents) {
        formParams.append('files', file, file.name);
      }
    }

    formParams.append('model', JSON.stringify(order));
    return this.http$.post<Order>(`/api/order/${orderId}/update`, formParams);
  }

  getOrder(orderId: number) {
    return this.http$.get<OrderData>(`/api/order/${orderId}`);
  }

  getOrderEditableStatus(orderId: number) {
    return this.http$.get<boolean>(`/api/order/${orderId}/editable`);
  }

  getOrderEyeViewDetails(orderId: number) {
    return this.http$.get<OrderEyeViewData>(`/api/order/${orderId}/orderDetail`);
  }

  getAllOrderSourcesList(from: Date | null, to: Date | null, filterColumn: 'Created Date' | 'Delivery Date' | 'Completed Date' | null) {
    const options = {

      params: {
        column: filterColumn || 'Delivery Date',
        from: from?.toUTCString() || '',
        to: to?.toUTCString() || ''
      }
    }
    return this.http$.get<OrderSource[]>('/api/order/sources', options);
  }

  getOrderPodData(orderId: number) {
    return this.http$.get<OrderPodData>(`api/order/${orderId}/pod`);
  }

  getOrderPodMetaData(orderId: number) {
    return this.http$.get<OrderPodData>(`api/order/${orderId}/pod/meta`);
  }

  getOrderPodImages(orderId: number) {
    return this.http$.get<any>(`api/order/${orderId}/pod/image`);
  }

  setOrderToCompleted(orderId: number, completedDate: string, receivedBy: string, podAttachments: File[]) {
    let formParams = new FormData();

    for (let file of podAttachments) {
      formParams.append('files', file, file.name);
    }

    const body = {
      orderId,
      completedDate: completedDate,
      receivedBy
    };

    formParams.append('model', JSON.stringify(body));
    return this.http$.post<boolean>('/api/order/complete', formParams);
  }

  updatePickConfirmedDate(orderId: number, setPickConfirmedDate: boolean) {
    return this.http$.post<boolean>(`/api/order/${orderId}/pickConfirmed`, {
      orderId: orderId,
      setPickConfirmedDate: setPickConfirmedDate
    });
  }

  getTemperatureTypes(): string[] {
      return Object.values(TemperatureTypeEnum);
  }
}
